import {stringify} from 'qs'
import request from 'company-management/utils/request'
import api from './api'

// 获取所有机器人列表
export async function getAllRobotList(payload) {
    return request(`${api.getAllRobotList.url}?${stringify(payload?.params)}`)
}

export async function getFailedList(payload) {
    return request(`${api.getFailedList.url}?${stringify(payload?.params)}`)
}

export async function getFailedStat(payload) {
    return request(`${api.getFailedStat.url}?${stringify(payload?.params)}`)
}

export async function exportFailed(payload) {
    return request(`${api.exportFailed.url}?${stringify(payload?.params)}`, null, {
        returnResponse: true,
    })
}

export async function companies(params) {
    return request(`${api.companies.url}${stringify(params, {addQueryPrefix: true})}`)
}
